// extracted by css-extract-rspack-plugin
export default {"field":"field--FCBCQo0nBg5byw86","title":"title--qEdGQ1tNR4koZr8t","content":"content--vAUqut0YCUxg4xgv"};